module.exports = __webpack_public_path__ + "static/media/icon4.e10e41f3.svg";